// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import styles from './StatTile.module.css';

export type StatTone = 'default' | 'ok' | 'warn' | 'err' | 'info' | 'accent';

export interface StatTileData {
  label: string;
  value: string | number;
  unit?: string;
  sub: string;
  tone?: StatTone;
  /** True when this one value isn't backed by a real field yet. */
  mocked?: boolean;
}

const TONE_CLASSES: Record<StatTone, string> = {
  default: '',
  ok: styles.toneOk,
  warn: styles.toneWarn,
  err: styles.toneErr,
  info: styles.toneInfo,
  accent: styles.toneAccent,
};

export default function StatTile({
  label,
  value,
  unit,
  sub,
  tone = 'default',
  mocked = false,
}: StatTileData) {
  const toneClass = TONE_CLASSES[tone];
  return (
    <div className={styles.tile}>
      <span className={styles.label}>
        {label}
        {mocked && <span className={styles.mockedBadge}>Mocked</span>}
      </span>
      <span className={styles.valueRow}>
        <span className={`${styles.value} ${toneClass}`}>{value}</span>
        {unit && <span className={`${styles.unit} ${toneClass}`}>{unit}</span>}
      </span>
      <span className={styles.sub}>{sub}</span>
    </div>
  );
}
